import { apiAxios } from '@/modules/core/app/helpers/AxiosHelper';
import { OnboardingFlow } from '@/modules/core/onboarding/onboarding.constants';

const FLOW_STATE_ROUTE = '/onboarding/flow/state';
const DASHBOARD_GENERATE_ROUTE = '/onboarding/autopilot/dashboard/generate';
const DASHBOARD_STATUS_ROUTE = '/onboarding/autopilot/dashboard/status';

class OnboardingResource {
  /**
   * @returns {Promise<{state: object, preferred_flow: string, completed_at: ?string}>}
   */
  async getFlowState() {
    return apiAxios.get(FLOW_STATE_ROUTE);
  }

  /**
   * @param {object} state
   * @param {string} preferredFlow
   * @returns {Promise<object>}
   */
  async saveFlowState(state, preferredFlow = OnboardingFlow.AUTOPILOT) {
    return apiAxios.post(FLOW_STATE_ROUTE, { state, preferred_flow: preferredFlow });
  }

  /**
   * Omits `state`, so saved progress is kept.
   *
   * @param {string} preferredFlow
   * @returns {Promise<object>}
   */
  async savePreferredFlow(preferredFlow = OnboardingFlow.AUTOPILOT) {
    return apiAxios.post(FLOW_STATE_ROUTE, { preferred_flow: preferredFlow });
  }

  /**
   * @param {object} params
   * @returns {Promise<{queued: boolean, build_token: string, reason: ?string}>}
   */
  async generateDashboard(params) {
    return apiAxios.post(DASHBOARD_GENERATE_ROUTE, params);
  }

  /**
   * @param {string} buildToken identifies the build started from the current answers
   * @returns {Promise<{status: string, page_id: number, reason: string, build_token: string}>}
   */
  async getDashboardBuildStatus(buildToken) {
    return apiAxios.get(DASHBOARD_STATUS_ROUTE, { params: { build_token: buildToken } });
  }
}

export default new OnboardingResource();
